import React from "react";
// import "./AdminUserList.css";
import { useDispatch } from "react-redux";
import { changeCurrentConfigurationMenu } from "../../store/screenSlice";
import { screenConfig } from "../../config/screenConfig";
import ButtonWithoutIcon from "../StyledComp/ButtonWithoutIcon";
import ReportServices from "../../services/ReportServices";
// import AdminUserCreation from "./AdminUserCreation";

const ConfigurationHeader: React.FC = () => {
  const dispatch = useDispatch();

  const ReconcileMenu = () => {
    console.log("ReconcileMenu");
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.adminUserConfiguration)
    );
  };

  const MemberCodeAdvancementMenu = () => {
    console.log("MemberCodeAdvancementMenu");
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.memberCodeAdvancementConfiguration)
    );
  };

  const PendingPaymentsMenu = () => {
    console.log("PendingPaymentsMenu");
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.pendingPaymentsConfiguration)
    );
  };

  const JobsMenu = () => {
    console.log("JobsMenu");
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.jobConfiguration)
    );
  };

  // const AdminUserCreation = () => {
  //   console.log("AdminUserCreation");
  //   dispatch(
  //     changeCurrentConfigurationMenu(
  //       screenConfig.adminUserCreationConfiguration
  //     )
  //   );
  // };

  // const MemberTypeMenu = () => {
  //   console.log("MemberTypeMenu");
  //   dispatch(
  //     changeCurrentConfigurationMenu(screenConfig.memberTypeConfiguration)
  //   );
  // };

  const MemberCodeMenu = () => {
    console.log("MemberCodeMenu");
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.memberCodeConfiguration)
    );
  };

  const MemberTagMenu = () => {
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.memberTagConfiguration)
    );
  };

  const MemberSectionMenu = () => {
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.memberSectionConfiguration)
    );
  };

  const FirmManagementMenu = () => {
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.FirmManagementConfiguration)
    );
  };

  const LocationMenu = () => {
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.LocationConfiguration)
    );
  };
  const CostMenu = () => {
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.CostConfiguration)
    );
  };
  const HelpVideosMenu = () => {
    dispatch(
      changeCurrentConfigurationMenu(screenConfig.HelpVideosConfiguration)
    );
  };

  const handleExportAssociateMembers = async () => {
    try {
      await ReportServices.downloadAssociateMembersTab();
    } catch (error) {
      console.error('Failed to export associate members:', error);
    }
  };

  const handleExportMemberDirectory = async () => {
    try {
      await ReportServices.downloadMemberDirectoryTab();
    } catch (error) {
      console.error('Failed to export member directory:', error);
    }
  };

  const handleExportFirms = async () => {
    try {
      await ReportServices.downloadFirmsTab();
    } catch (error) {
      console.error('Failed to export firms:', error);
    }
  };

  return (
    <div className="dashboard-menu-wrapper-left-tab d-none d-lg-flex w-100">
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Reconcile"
          onClick={ReconcileMenu}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Jobs"
          onClick={JobsMenu}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Member Code Advancement"
          onClick={MemberCodeAdvancementMenu}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Pending Payments"
          onClick={PendingPaymentsMenu}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Export Associate Members"
          onClick={handleExportAssociateMembers}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Export Member Directory"
          onClick={handleExportMemberDirectory}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Export Firms"
          onClick={handleExportFirms}
        />
      </div>
      {/* <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Member Code"
          onClick={MemberCodeMenu}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Member Section"
          onClick={MemberSectionMenu}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Member Tag"
          onClick={MemberTagMenu}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Firm Management"
          onClick={FirmManagementMenu}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Location"
          onClick={LocationMenu}
        />
      </div>
      <div className="dashboard-menu-button">
        <ButtonWithoutIcon
          buttontext="Cost"
          onClick={CostMenu}
        />
      </div> */}
    </div>
  );
};

export default ConfigurationHeader;
